import React from "react";
import "./styles/PageActionButton.css";

/**
 * PageActionButton - Two-line action for page headers
 * @param {Object} props
 * @param {React.ReactNode} props.icon - Icon component
 * @param {string} props.label - Primary label
 * @param {string} props.info - Secondary info text
 * @param {Function} props.onClick - Click handler
 * @param {boolean} props.loading - Loading state
 * @param {boolean} props.disabled - Disabled state
 * @param {string} props.variant - Visual variant ('default', 'primary', 'export', 'import')
 */
const PageActionButton = ({
  icon,
  label,
  info,
  onClick,
  loading = false,
  disabled = false,
  variant = "default",
}) => {
  return (
    <button
      type="button"
      className={`pageActionButton ${variant} ${loading ? "loading" : ""}`}
      onClick={onClick}
      disabled={disabled || loading}
      title={info ? `${label} — ${info}` : label}
    >
      <span className="buttonIcon">
        {loading ? (
          /* Inherits the button's own colour, so it stays legible on
             both the surface and primary variants. */
          <span className="pageActionButtonSpinner" aria-hidden="true" />
        ) : (
          icon
        )}
      </span>
      <span className="buttonLabels">
        <span className="buttonLabel">{label}</span>
        {info && <span className="buttonInfo">{info}</span>}
      </span>
    </button>
  );
};

export default PageActionButton;
